/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal, ModalFuncProps, Typography } from 'antd';

/**
 * Opens a confirmation modal for archiving a run.
 * @param config - The configuration object for the modal.
 * @param config.onOk - The callback function to be executed when the "Archive" button is clicked.
 * @param config.title - The title of the modal. If not provided, a default title will be used.
 * @returns A Modal.confirm instance.
 */
export const openArchiveRunConfirmModal = (config: {
  onOk: ModalFuncProps['onOk'];
  title?: ModalFuncProps['title'];
}) => {
  return Modal.confirm({
    onOk: config.onOk,
    title: config.title || `Archive the Run`,
    content: (
      <Typography.Text
        type="secondary"
        data-cy="archive-run-confirm-description"
      >
        The runs and exceptions can be un-archived at any time from &quot;Show
        all Runs&quot; view.
      </Typography.Text>
    ),
    icon: <ExclamationCircleFilled />,
    okText: 'Archive',
    cancelText: 'Cancel',
    okButtonProps: {
      danger: true,
      type: 'primary',
      'data-cy': 'archive-run-confirm'
    }
  });
};
